/** @format */

export const baseURL = process.env.REACT_APP_BASE_URL || "http://localhost:5001/";
export const secretKey = process.env.REACT_APP_SECRET_KEY || "uG$BVA3xOFAS%b6V-AtrUCrBMwxmO1TKeiIXiWw~!p94";
export const projectName = process.env.REACT_APP_PROJECT_NAME || "Declotr";
